import React, { cloneElement, Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setAnsweringQuestionsAction } from "../../../../redux/answeringQuestions/answeringQuestions";
import { setQuestionViewAction } from "../../../../redux/answeringQuestions/questionView";
import useScribbleTooltip from "../../../../hooks/answeringQuestions/useScribbleTooltip";
import useAmplitude from "../../../../hooks/useAmplitude";

const KeypadShower = ( props ) => {

  const dispatch = useDispatch();
  const answeringQuestions = useSelector(state => state.answeringQuestions);
  const setAnsweringQuestions = payload => { dispatch( setAnsweringQuestionsAction( payload ) ) };
  const setQuestionView = payload => { dispatch(setQuestionViewAction(payload)) };
  const { setAmplitudeLog } = useAmplitude();

  const { hideScribbleTooltip } = useScribbleTooltip();

  const show = () => {
    setQuestionView({ isErase: false });
    const event = !answeringQuestions?.learningType 
      ? { eventCategory: 'test', eventName: '진단연습장 종료' }
      : { eventCategory: 'learning', eventName: '학습연습장 종료' }
    setAmplitudeLog(event);
    
    setAnsweringQuestions( { isShowKeypad : true } );
    hideScribbleTooltip();
  };

  return cloneElement( props.children || <Fragment />, { onShow : show } );

};

export default KeypadShower;
